export const types = {
    CAPTURETEXTFROMIMAGE: 'CAPTURE-TEXT-FROM-IMAGE',
    IMAGETOTEXT: 'IMAGE-TO-TEXT'
};